<template>
	<div class="app-notifications-container">
		<TransitionGroup name="notification-slide">
			<app-notification-item
				v-for="notification in notifications"
				:key="notification.id"
				:notification="notification"
				@close="handleClose"
			/>
		</TransitionGroup>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNotification } from '@/composables/useNotification'
import AppNotificationItem from "@/components/ui-kit/notifications/AppNotificationItem.vue";

const notificationService = useNotification()
const notifications = computed(() => notificationService.notifications.value)

const handleClose = (id: number) => {
	notificationService.remove(id)
}
</script>

<style scoped>
.app-notifications-container {
	position: fixed;
	bottom: 20px;
	right: 20px;
	z-index: 9999;
	display: flex;
	flex-direction: column-reverse;
	gap: 10px;
	max-width: 350px;
	width: 100%;
}

/* Анимации */
.notification-slide-enter-active,
.notification-slide-leave-active {
	transition: all 0.3s ease;
}

.notification-slide-enter-from {
	opacity: 0;
	transform: translateX(100%);
}

.notification-slide-leave-to {
	opacity: 0;
	transform: translateX(100%);
}

.notification-slide-move {
	transition: transform 0.5s ease;
}
</style>
